import { errorWithoutThrowInProduction } from "lib/logging/logHelper";
import { PostQaUserReviewCommentNotificationApiRequestQuery } from "faqSrc/pages/api/questionAnswers/[questionAnswerId]/userReviews/reviewComments/[reviewCommentId]/notifications";

type Response = {
  isSuccess: boolean;
};

export async function postQaUserReviewCommentNotificationApi({
  questionAnswerId,
  reviewCommentId,
}: PostQaUserReviewCommentNotificationApiRequestQuery): Promise<Response> {
  const reqBody = { questionAnswerId, reviewCommentId };
  const res = await fetch(
    `/api/questionAnswers/${questionAnswerId}/userReviews/reviewComments/${reviewCommentId}/notifications`,
    {
      body: JSON.stringify(reqBody),
      headers: {
        "Content-type": "application/json",
      },
      method: "POST",
    }
  );

  const isSuccess = res.status === 200;

  if (!isSuccess) {
    const resJson = await res.json();
    errorWithoutThrowInProduction({
      errorInfo: {
        reqBody,
        response: { body: resJson, status: res.status },
      },
      errorMessage:
        "Failed to call /api/questionAnswers/[questionAnswerId]/userReviews/reviewComments/[reviewCommentId]/notifications",
    });
  }

  return { isSuccess };
}
